import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { flatMap, mergeMap, map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MobileService {
  private baseUrl = environment.API;


  constructor(
    private httpClient: HttpClient
    ) { }


public sendCode(phoneNumber): Observable<any> {
  const url = `${this.baseUrl}/users/register/sendcode/`;
  return this.httpClient.post(url, {'username': phoneNumber}).pipe(catchError(err => {
    return throwError(err);
  }));
}

public verifyMobileNumber(phoneNumber, code): Observable<any> {
  const payload = {
    'username': phoneNumber,
    'code': code
  };
  const url = `${this.baseUrl}/users/verify/`;
  return this.httpClient.post(url, payload);
}
}



